import LearnersCreating from "../../../../../components/Insights/StoriesSnapShot/LearnersCreating";
import HowTheyLearning from "../../../../../components/Insights/StoriesSnapShot/HowTheyLearning";
import SchoolWork from "../../../../../components/Insights/SchoolWork/SchoolWork";
import HowStudentDoing from "../../../../../components/Insights/Admin/HowStudentDoing";
import "./Adminstyles.scss";
import NotesAboutStudent from "../../../../../components/Insights/Admin/NotesAboutStudent";

function AdminStudentView({
  name,
  data,
  loading,
  selData,
  userId,
  schoolHash,
  classId,
  isStudent,
}: {
  name: string;
  data: any;
  loading?: boolean;
  selData?: any;
  isStudent?: boolean;
  userId?: string;
  schoolHash?: string;
  classId?: string;
}) {
  const title = `${name}'s` + " work";
  return (
    <>
      <LearnersCreating
        loading={loading}
        isstoryProgress={true}
        name={name}
        classroomData={data}
      />
      <HowStudentDoing loading={loading} studentName={name} data={data} />
      <HowTheyLearning
        loading={loading}
        isSchool={true}
        selData={selData}
        name={name}
        userId={userId}
        schoolHash={schoolHash}
        classId={classId}
        isStudent={isStudent}
      />
      <NotesAboutStudent
        loading={loading}
        schoolDashboardData={data}
        studentname={name}
        userId={userId || ""}
        schoolHash={schoolHash || ""}
        classId={classId || ""}
      />
    </>
  );
}

export default AdminStudentView;
